import {Button, Dropdown, Form, InputNumber, List, MenuProps, Space, Spin} from "antd";
import {useContext} from "react";
import {DeleteOutlined, DownOutlined} from "@ant-design/icons";
import {useGetCurrencyQuery} from "../../../../api/priceApi";
import {CatalogContext, ProductPriceType} from "../../../../providers/CatalogProvider";

const ProductCurrenciesItem = () => {
    const {product, setProduct} = useContext(CatalogContext)

    const {data: currencies, isLoading} = useGetCurrencyQuery(null)

    const minCurrencyAmount = "0"

    const items = currencies && currencies.map(item => {
        const {id, name, code} = item

        return {
            label: name,
            key: id,
            disabled: !!(product.price as ProductPriceType[]).find(
                currency => currency.code === code
            )
        }
    })

    const onClick: MenuProps['onClick'] = (e) => {
        const foundItem = currencies && currencies.find(
            currency => currency.id.toString() === e.key
        )

        setProduct({
            ...product,
            price: [
                ...(product.price as ProductPriceType[]),
                {
                    id: +e.key,
                    amount: minCurrencyAmount,
                    code: foundItem!.code
                }
            ]
        })
    }

    return (
        <Form.Item label="Currency">
            {
                isLoading
                    ? <Spin size="small"/>
                    : <List
                        itemLayout="vertical"
                        size="large"
                        dataSource={product.price as ProductPriceType[]}
                        renderItem={item => (
                            <List.Item key={item.id}>
                                <div style={{display: 'flex', gap: 5, alignItems: 'center'}}>
                                    <span>{item.code}</span>

                                    <InputNumber
                                        value={item.amount}
                                        style={{width: '100%'}}
                                        placeholder="99.99"
                                        step="0.01"
                                        stringMode
                                        onChange={e => {
                                            const filteredCurrency: ProductPriceType[] = (product.price as ProductPriceType[]).map(currency => {
                                                const {amount, id, code} = currency
                                                return {id, code, amount: id === item.id && e ? e : amount}
                                            })

                                            setProduct(prevState => ({...prevState, price: [...filteredCurrency]}))
                                        }}
                                    />

                                    <Button
                                        onClick={() => {
                                            const filteredCurrency = (product.price as ProductPriceType[]).filter(
                                                currency => currency.id !== item.id
                                            )

                                            setProduct(prevState => ({...prevState, price: filteredCurrency}))
                                        }}
                                        type="link"
                                        size="small"
                                    >
                                        <DeleteOutlined/>
                                    </Button>
                                </div>
                            </List.Item>
                        )}
                        footer={
                            <Dropdown menu={{items, onClick}}>
                                <Button style={{width: '100%'}}>
                                    <Space>
                                        Add Currency <DownOutlined/>
                                    </Space>
                                </Button>
                            </Dropdown>
                        }
                    />
            }
        </Form.Item>
    );
};

export default ProductCurrenciesItem;
